<template>
    <v-container fluid>
        <v-row no-gutters class="d-flex justify-center" style="height: 8vh">
            <v-col cols="1">
                <v-btn-back @click="back()" data-cy="EngagementLetter-button-back"> </v-btn-back>
            </v-col>
            <v-col cols="7" class="headline mb-5 d-flex align-center">Lettre de mission</v-col>
            <v-col cols="4" class="d-flex justify-end align-center" v-if="data.status === 'DRAFT'">
                <v-btn
                    variant="outlined"
                    elevation="0"
                    @click="save()"
                    class="mx-1"
                    size="small"
                    data-cy="Engagement-save"
                >
                    Enregistrer
                </v-btn>
                <v-btn
                    elevation="0"
                    :disabled="!isValid"
                    @click="validate()"
                    class="mx-1"
                    data-cy="EngagementLetters-valid"
                    size="small"
                >
                    Valider
                </v-btn>
            </v-col>
            <v-col cols="4" class="d-flex justify-end" v-else-if="data.status === 'VALIDATED'">
                <v-btn
                    variant="outlined"
                    elevation="0"
                    @click="modify()"
                    class="mx-1"
                    data-cy="EngagementLetters-modif"
                    size="small"
                >
                    Modifier
                </v-btn>
                <v-btn
                    v-if="localEnv !== 'production'"
                    variant="outlined"
                    elevation="0"
                    @click="askForSignature()"
                    class="mx-1"
                    size="small"
                >
                    Signer
                </v-btn>
                <v-btn
                    elevation="0"
                    :disabled="!isValid"
                    @click="printPDF()"
                    class="mx-1"
                    data-cy="EngagementLetters-downloadPDF"
                    size="small"
                >
                    Télécharger le PDF
                </v-btn>
                <v-btn
                    elevation="0"
                    :disabled="!isValid"
                    @click="printDocx()"
                    class="mx-1"
                    data-cy="EngagementLetters-downloadDocx"
                    size="small"
                >
                    Télécharger le Docx
                </v-btn>
                <v-btn
                    elevation="0"
                    :disabled="!isValid"
                    @click="dialogUploadSignedDocument = true"
                    class="mx-1"
                    data-cy="EngagementLetters-signe"
                    size="small"
                >
                    Signée !
                </v-btn>
            </v-col>
            <v-col cols="4" class="d-flex justify-end ml-5" v-else-if="data.status === 'SIGNED'">
                <v-btn
                    elevation="0"
                    :disabled="!isValid"
                    @click="printPDF()"
                    class="mx-1"
                    data-cy="EngagementLetters-downloadPDFSigne"
                    size="small"
                >
                    Télécharger le PDF
                </v-btn>
            </v-col>
        </v-row>
        <v-row
            no-gutters
            class="d-flex justify-center"
            :style="'max-height:' + maxHeight + ';' + 'overflow:auto'"
        >
            <v-col cols="15">
                <v-card class="default_card" elevation="0">
                    <v-row no-gutters class="py-2 px-3">
                        <v-col cols="2">
                            <v-tabs
                                v-model="step"
                                direction="vertical"
                                background-color="rgba(0,0,0,0)"
                                class="fill-height"
                            >
                                <v-tab
                                    value="0"
                                    data-cy="EngagementLetters-societyClient"
                                    style="justify-content: center"
                                >
                                    Société / Client
                                </v-tab>
                                <v-tab
                                    value="1"
                                    data-cy="EngagementLetters-cebinetContrat"
                                    style="justify-content: center"
                                >
                                    Cabinet / Contrat
                                </v-tab>
                                <v-tab
                                    value="2"
                                    data-cy="EngagementLetters-tarification"
                                    style="justify-content: center"
                                >
                                    Tarification
                                </v-tab>
                                <v-tab
                                    value="3"
                                    data-cy="EngagementLetters-travaux"
                                    style="justify-content: center"
                                >
                                    Répartition des Travaux
                                </v-tab>
                            </v-tabs>
                        </v-col>
                        <v-col cols="15">
                            <v-tabs-window
                                v-model="step"
                                class="pa-4"
                                style="background: rgba(0, 0, 0, 0)"
                            >
                                <!-- Société / Client -->
                                <v-window-item value="0">
                                    <v-row no-gutters>
                                        <v-col cols="6" class="pr-2 pb-2">
                                            <span class="title"> Société prospectée </span>
                                            <v-card
                                                class="inside_card rounded-xl fill-height"
                                                @click="accessDialogCompany()"
                                                :readonly="!isEditable"
                                                elevation="0"
                                                :ripple="isEditable"
                                            >
                                                <v-card-title
                                                    primary-title
                                                    style="padding-top: 5px; padding-bottom: 5px"
                                                >
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="8"
                                                            data-cy="EngagementLetter-companyName"
                                                        >
                                                            {{ data.prospectedCompany.name }}
                                                        </v-col>
                                                        <v-col cols="4" class="d-flex justify-end">
                                                            <v-btn
                                                                elevation="0"
                                                                v-if="isEditable"
                                                                data-cy="EngagementLetter-edit"
                                                                size="small"
                                                            >
                                                                éditer
                                                                <v-icon size="small" location="end"
                                                                    >$edit</v-icon
                                                                >
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            :class="{
                                                                'text-red':
                                                                    !data.prospectedCompany.siret,
                                                            }"
                                                            data-cy="EngagementLetter-siret"
                                                        >
                                                            Siret:
                                                            {{
                                                                getSiretValue(
                                                                    data.prospectedCompany.siret,
                                                                ) || "manquant"
                                                            }}
                                                        </v-col>

                                                        <v-col
                                                            cols="12"
                                                            :class="{
                                                                'text-red':
                                                                    !data.prospectedCompany
                                                                        .address ||
                                                                    !data.prospectedCompany
                                                                        .postalCode ||
                                                                    !data.prospectedCompany.city,
                                                            }"
                                                            data-cy="EngagementLetter-adress"
                                                        >
                                                            Adresse:
                                                            {{ data.prospectedCompany.address }}
                                                            {{ data.prospectedCompany.postalCode }}
                                                            {{ data.prospectedCompany.city }}
                                                        </v-col>

                                                        <v-col
                                                            cols="12"
                                                            :class="{
                                                                'text-red':
                                                                    !data.prospectedCompany
                                                                        .legalForm,
                                                            }"
                                                            data-cy="EngagementLetter-legalForm"
                                                        >
                                                            {{ $t("settings.legalForm") }}:
                                                            {{
                                                                data.prospectedCompany.legalForm ||
                                                                "manquant"
                                                            }}
                                                        </v-col>
                                                    </v-row>
                                                    <!-- <v-flex
                                                            xs12
                                                            :class="data.prospectedCompany.taxSystem ? '' : 'text-red'"
                                                        >
                                                            Régime TVA :
                                                            {{ data.prospectedCompany.taxSystem? taxSystems[userCompany.taxSystem] : "manquant" }}
                                                        </v-flex>
                                                        <v-flex
                                                            xs12
                                                            :class="data.prospectedCompany.registrationTown ? '' : 'text-red'"
                                                        >
                                                            Ville d'enregistrement RCS :
                                                            {{ data.prospectedCompany.registrationTown || "manquant" }}
                                                        </v-flex> -->
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col class="pl-2 pb-2" cols="6">
                                            <span class="title">Client prospecté</span>
                                            <v-card
                                                class="inside_card rounded-xl fill-height"
                                                elevation="0"
                                            >
                                                <v-card-text>
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <v-radio-group
                                                                class="my-0 py-0"
                                                                color="primary"
                                                                v-model="
                                                                    data.prospectedClient.gender
                                                                "
                                                                :readonly="!isEditable"
                                                                inline
                                                            >
                                                                <v-radio
                                                                    class="my-0 py-0"
                                                                    label="Homme"
                                                                    :value="'man'"
                                                                    data-cy="EngagementLetter-man"
                                                                />
                                                                <v-radio
                                                                    class="my-0 py-0"
                                                                    label="Femme"
                                                                    :value="'woman'"
                                                                />
                                                            </v-radio-group>
                                                        </v-col>
                                                        <v-col cols="6" class="mb-1 px-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedClient.firstname
                                                                "
                                                                label="Prénom"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                data-cy="EngagementLetter-fistName"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="mb-1 px-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedClient.lastname
                                                                "
                                                                label="Nom"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                data-cy="EngagementLetter-lastName"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="mt-1 px-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedClient
                                                                        .phoneNumber
                                                                "
                                                                label="Numero de téléphone"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                data-cy="EngagementLetter-phone"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="mt-1 px-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedClient.email
                                                                "
                                                                label="Email"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                data-cy="EngagementLetter-email"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12" class="pr-2 pt-6">
                                            <div class="title">
                                                Informations complémentaires sur la société
                                            </div>
                                            <v-card class="inside_card rounded-xl" elevation="0">
                                                <v-card-text>
                                                    <v-row no-gutters>
                                                        <v-col cols="12" class="mb-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .activityDetails
                                                                "
                                                                label="Détail de l'activité"
                                                                :readonly="!isEditable"
                                                                outlined
                                                                hide-details
                                                                density="compact"
                                                                data-cy="EngagementLetter-activityDetails"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="my-1 pr-1">
                                                            <oss-date-picker-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .establishmentDate
                                                                "
                                                                :label="'Date de création de la société'"
                                                                :readonly="!isEditable"
                                                                :textFieldReadOnly="false"
                                                                hide-details
                                                                prefixDataCy="EngagementLetter-creation"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="my-1 pl-1">
                                                            <oss-date-picker-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .endFinancialYear
                                                                "
                                                                :label="'Date de fin d\'exercice'"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                prefixDataCy="EngagementLetter-endFinancial"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="my-1 pr-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .shareCapital
                                                                "
                                                                :label="'Montant du capital social'"
                                                                :readonly="!isEditable"
                                                                hide-details="auto"
                                                                data-cy="EngagementLetter-shareCapital"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="my-1 pl-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .numberOfEmployees
                                                                "
                                                                :label="'Nombre de salarié(s)'"
                                                                :readonly="!isEditable"
                                                                hide-details="auto"
                                                                density="compact"
                                                                data-cy="EngagementLetter-numberOfEmployees"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="my-1 pr-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .forecastTurnover
                                                                "
                                                                :label="'Chiffre d\'affaires prévisionnel'"
                                                                :readonly="!isEditable"
                                                                hide-details="auto"
                                                                data-cy="EngagementLetter-forecastTurnover"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="my-1 pl-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .lastYearTurnover
                                                                "
                                                                :label="'Chiffre d\'affaires année N-1'"
                                                                :readonly="!isEditable"
                                                                hide-details="auto"
                                                                data-cy="EngagementLetter-lastYearTurnover"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="mt-1 pr-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .estimatedNumberOfInvoice
                                                                "
                                                                label="Estimation du nb de factures par an"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                density="compact"
                                                                data-cy="EngagementLetter-estimatedNumberOfInvoice"
                                                            />
                                                        </v-col>
                                                        <v-col cols="6" class="mt-1 pl-1">
                                                            <v-text-field-filled
                                                                v-model="
                                                                    data.prospectedCompany
                                                                        .numberOfBankAccount
                                                                "
                                                                label="Nb de compte(s) bancaire(s)"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                density="compact"
                                                                data-cy="EngagementLetter-numberOfBankAccount"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item value="1">
                                    <v-row no-gutters>
                                        <v-col cols="4" class="pr-2 pb-2">
                                            <span class="title">Contrat</span>
                                            <v-card class="inside_card rounded-xl" elevation="0">
                                                <v-card-text>
                                                    <v-row no-gutters>
                                                        <v-col cols="12" class="mb-1 mx-1">
                                                            <oss-date-picker-filled
                                                                v-model="data.contractBegin"
                                                                :label="'Date de début du contrat'"
                                                                :readonly="!isEditable"
                                                                :textFieldReadOnly="false"
                                                                hide-details
                                                                prefixDataCy="EngagementLetter-beginContrat"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" class="mt-1 mx-1">
                                                            <oss-date-picker-filled
                                                                v-model="data.contractEnd"
                                                                :label="'Date de fin du contrat'"
                                                                :readonly="!isEditable"
                                                                :textFieldReadOnly="false"
                                                                hide-details
                                                                prefixDataCy="EngagementLetter-endContrat"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="4" class="pl-2 pb-2">
                                            <span class="title">Réalisation du contrat</span>
                                            <v-card class="inside_card rounded-xl" elevation="0">
                                                <v-card-text>
                                                    <v-row no-gutters>
                                                        <v-col cols="12" class="mb-1 mx-1">
                                                            <v-text-field-filled
                                                                v-model="data.localizationCreation"
                                                                label="Fait à ..."
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                data-cy="EngagementLetter-ville"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" class="mt-1 mx-1">
                                                            <oss-date-picker-filled
                                                                v-model="data.contractDateCreation"
                                                                :label="'En date du ...'"
                                                                :readonly="!isEditable"
                                                                :textFieldReadOnly="false"
                                                                hide-details
                                                                data-cy="EngagementLetter-dateCreation"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="6" class="pt-2 pr-2">
                                            <span class="title">Expert-comptable</span>
                                            <v-card class="inside_card rounded-xl" elevation="0">
                                                <v-card-text>
                                                    <v-row no-gutters>
                                                        <v-col cols="12" class="mb-1">
                                                            <v-text-field-filled
                                                                v-model="data.accountant.firstname"
                                                                label="Prénom"
                                                                readonly
                                                                hide-details
                                                                density="compact"
                                                                data-cy="EngagementLetter-accountantFirstName"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" class="mt-1">
                                                            <v-text-field-filled
                                                                v-model="data.accountant.lastname"
                                                                label="Nom"
                                                                readonly
                                                                hide-details
                                                                density="compact"
                                                                data-cy="EngagementLetter-accountantLastName"
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            class="py-2"
                                                            v-if="isEditable"
                                                        >
                                                            <v-divider />
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            style="
                                                                max-height: 45vh;
                                                                overflow-y: auto;
                                                            "
                                                            v-if="isEditable"
                                                        >
                                                            <select-user
                                                                class="px-1"
                                                                v-model="data.accountant"
                                                                :companyId="companyId"
                                                                :type="'NATURAL_PERSON'"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="6" class="pt-2 pl-2">
                                            <span class="title">Condition de fin de contrat</span>
                                            <v-card class="inside_card rounded-xl" elevation="0">
                                                <v-card-text>
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <v-switch
                                                                v-model="
                                                                    data.cg_endOfContractCondition
                                                                "
                                                                :readonly="!isEditable"
                                                                label="Pénalités si rupture après préavis 3 mois"
                                                                data-cy="EngagementLetter-penality"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-select-filled
                                                                v-model="data.commercialCourt"
                                                                :items="commercialCourts"
                                                                item-value="value"
                                                                item-title="text"
                                                                return-object
                                                                :readonly="!isEditable"
                                                                label="Tribunal de commerce"
                                                                data-cy="EngagementLetter-commerce"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                            <span class="title mt-3">Contact du cabinet</span>
                                            <v-card class="inside_card rounded-xl" elevation="0">
                                                <v-card-text>
                                                    <div>
                                                        <v-text-field-filled
                                                            v-model="data.accounting_phoneNumber"
                                                            label="Numero de téléphone"
                                                            :readonly="!isEditable"
                                                            hide-details
                                                            data-cy="EngagementLetter-telephone"
                                                            density="compact"
                                                        />
                                                    </div>
                                                    <div class="pt-2">
                                                        <v-text-field-filled
                                                            v-model="data.accounting_email"
                                                            label="Email"
                                                            :readonly="!isEditable"
                                                            hide-details
                                                            data-cy="EngagementLetter-mail"
                                                            density="compact"
                                                        />
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item value="2">
                                    <v-row no-gutters>
                                        <v-col cols="4" class="pr-2">
                                            <v-card
                                                class="inside_card rounded-xl mb-4"
                                                elevation="0"
                                            >
                                                <v-card-title> Frais de dossier </v-card-title>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="12" class="d-flex px-2 pb-2">
                                                            <v-text-field-filled
                                                                v-model.number="data.applicationFee"
                                                                append-inner-icon="$fa-percent"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                dense
                                                                data-cy="EngagementLetter-fraisDossier"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="4" class="px-2">
                                            <v-card
                                                class="inside_card rounded-xl mb-4"
                                                elevation="0"
                                            >
                                                <v-card-title> Type de facturation </v-card-title>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="12" class="d-flex px-2 pb-2">
                                                            <v-select-filled
                                                                v-model="data.reccurency"
                                                                :items="reccurencyTypes"
                                                                item-title="text"
                                                                item-value="value"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                data-cy="EngagementLetter-facturation"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="4" class="px-2">
                                            <v-card
                                                class="inside_card rounded-xl mb-4"
                                                elevation="0"
                                            >
                                                <v-card-title> Délai de paiement </v-card-title>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="12" class="d-flex px-2 pb-2">
                                                            <v-text-field-filled
                                                                v-model.number="data.paymentDelay"
                                                                append-inner-icon="$oss-calendar"
                                                                label="Nombre de jours"
                                                                :readonly="!isEditable"
                                                                hide-details
                                                                data-cy="EngagementLetter-days"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-list tree-line>
                                                <v-list-item :active="false" :link="false">
                                                    <template v-slot:append>
                                                        <v-row no-gutters style="width: 132px">
                                                            <v-col
                                                                cols="12"
                                                                class="d-flex align-center justify-start"
                                                            >
                                                                Annuelle
                                                            </v-col>
                                                        </v-row>
                                                    </template>
                                                    <v-row no-gutters>
                                                        <v-col cols="8">
                                                            Intitulé de la prestation
                                                        </v-col>
                                                        <v-col cols="4" class="d-flex">
                                                            Montant (HT)
                                                        </v-col>
                                                    </v-row></v-list-item
                                                >
                                                <v-list-item
                                                    v-for="(item, index) of data.items"
                                                    :key="index"
                                                    :active="false"
                                                    :link="false"
                                                >
                                                    <template
                                                        v-slot:append
                                                        class="my-0 d-flex align-center"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col
                                                                cols="6"
                                                                class="d-flex align-center justify-center px-4 py-1"
                                                            >
                                                                <v-switch
                                                                    v-model="item.annualPayment"
                                                                    class="my-0"
                                                                    :readonly="!isEditable"
                                                                    hide-details
                                                                    :data-cy="`EngagementLetter-annualPayment-${index}`"
                                                                />
                                                            </v-col>
                                                            <v-col
                                                                cols="6"
                                                                class="d-flex align-center justify-center pl-4"
                                                            >
                                                                <v-btn-icon
                                                                    icon="$delete"
                                                                    @click="deleteItem(index)"
                                                                    v-if="isEditable"
                                                                    :data-cy="`EngagementLetter-delete-${index}`"
                                                                />
                                                            </v-col>
                                                        </v-row>
                                                    </template>
                                                    <v-row no-gutters>
                                                        <v-col cols="8">
                                                            <v-text-field-filled
                                                                v-model="item.title"
                                                                :readonly="!isEditable"
                                                                outlined
                                                                hide-details
                                                                density="compact"
                                                                :data-cy="`EngagementLetter-title-${index}`"
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="d-flex align-center pl-10"
                                                        >
                                                            <oss-text-field
                                                                v-model="item.amount"
                                                                :readonly="!isEditable"
                                                                content-class="mr-3"
                                                                :min="'0'"
                                                                hide-details
                                                                :data-cy="`EngagementLetter-amount-${index}`"
                                                            />
                                                        </v-col> </v-row
                                                ></v-list-item>
                                                <InvoiceProductsDialog
                                                    v-if="isEditable"
                                                    :companyId="companyId"
                                                    @valid="addProduct($event)"
                                                    data-cy="EngagementLetter-valider"
                                                >
                                                    <template v-slot:activator="{ props }">
                                                        <v-list-item
                                                            ripple
                                                            class="mx-3 rounded-xl"
                                                            border
                                                            v-bind="props"
                                                            data-cy="EngagementLetter-addLigne"
                                                        >
                                                            <template v-slot:append>
                                                                <v-icon color="primary">
                                                                    $add
                                                                </v-icon>
                                                            </template>
                                                            <v-row no-gutters>
                                                                <v-col
                                                                    cols="12"
                                                                    class="d-flex justify-center"
                                                                >
                                                                    Ajouter une ligne
                                                                </v-col>
                                                            </v-row></v-list-item
                                                        >
                                                    </template>
                                                </InvoiceProductsDialog>
                                            </v-list>
                                        </v-col>
                                        <v-col cols="12" class="pt-4">
                                            <v-card class="inside_card rounded-xl" elevation="0">
                                                <v-card-title>
                                                    <v-row>
                                                        <v-col cols="6"> Tarif mensuel </v-col>
                                                        <v-col
                                                            cols="6"
                                                            class="d-flex justify-end px-2 pb-2"
                                                            data-cy="EngagementLetter-total"
                                                        >
                                                            {{
                                                                newCommonFormatCurrency(
                                                                    totalPrice,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </v-col>
                                                    </v-row>
                                                </v-card-title>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item value="3">
                                    <v-row no-gutters>
                                        <v-col cols="7" class="d-flex align-center">
                                            <span class="title"
                                                >Description du périmètre d&#x2019;intervention |
                                                Répartition des travaux</span
                                            >
                                        </v-col>
                                        <v-col cols="4">
                                            <v-switch
                                                v-model="taskDistributionBobbeeMode"
                                                hide-details
                                                label="Distribution des t&#xe2;ches façon bobbee"
                                                class="my-0"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            v-if="taskDistributionBobbeeMode"
                                            :key="update"
                                        >
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="1"
                                                    class="d-flex justify-end align-center pr-1"
                                                >
                                                    <v-btn-icon
                                                        icon="
                                                            $fa-chevron-up
                                                        "
                                                        size="small"
                                                        :disabled="panel === 0 || panelIsNaN"
                                                        @click="panel--"
                                                    />
                                                    <v-btn-icon
                                                        icon="
                                                            $fa-chevron-down
                                                        "
                                                        :disabled="
                                                            panel ===
                                                                data.taskDistribution.length - 1 ||
                                                            panelIsNaN
                                                        "
                                                        @click="panel++"
                                                        data-cy="Engagement-nextTask"
                                                    />
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-expansion-panels
                                                        accordion
                                                        flat
                                                        v-model="panel"
                                                    >
                                                        <v-expansion-panel
                                                            v-for="(
                                                                task, i
                                                            ) in data.taskDistribution"
                                                            :key="i"
                                                            style="background: transparent"
                                                        >
                                                            <v-expansion-panel-title
                                                                class="primary--text"
                                                            >
                                                                <strong>{{
                                                                    $t(
                                                                        "engagementLetter.wordings." +
                                                                            task.name,
                                                                    )
                                                                }}</strong>
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <v-card
                                                                    class="rounded-xl"
                                                                    elevation="0"
                                                                    style="overflow: hidden"
                                                                >
                                                                    <v-row
                                                                        no-gutters
                                                                        class="d-flex justify-center"
                                                                    >
                                                                        <v-col cols="12">
                                                                            <v-list
                                                                                style="
                                                                                    background-color: transparent;
                                                                                "
                                                                                lines="two"
                                                                            >
                                                                                <template
                                                                                    v-for="item in task.subs"
                                                                                    :key="
                                                                                        'a_' +
                                                                                        item.name
                                                                                    "
                                                                                >
                                                                                    <v-list-item
                                                                                        ripple
                                                                                        rounded
                                                                                        class="oss-list-item"
                                                                                    >
                                                                                        <v-row
                                                                                            no-gutters
                                                                                        >
                                                                                            <v-col
                                                                                                cols="8"
                                                                                                class="d-flex align-center"
                                                                                            >
                                                                                                {{
                                                                                                    $t(
                                                                                                        "engagementLetter.wordings." +
                                                                                                            item.name,
                                                                                                    )
                                                                                                }}
                                                                                            </v-col>
                                                                                            <v-col
                                                                                                cols="4"
                                                                                                class="d-flex align-center justify-center"
                                                                                            >
                                                                                                <template
                                                                                                    v-if="
                                                                                                        item.included
                                                                                                    "
                                                                                                >
                                                                                                    Inclus
                                                                                                </template>
                                                                                                <template
                                                                                                    v-else-if="
                                                                                                        item.isDefinable
                                                                                                    "
                                                                                                >
                                                                                                    <v-radio-group
                                                                                                        color="primary"
                                                                                                        v-model="
                                                                                                            item.realizedBy
                                                                                                        "
                                                                                                        class="my-0 py-0"
                                                                                                        :disabled="
                                                                                                            item.included
                                                                                                        "
                                                                                                        :readonly="
                                                                                                            !isEditable
                                                                                                        "
                                                                                                        inline
                                                                                                        hide-details
                                                                                                    >
                                                                                                        <v-radio
                                                                                                            class="my-0 py-0"
                                                                                                            label="Client"
                                                                                                            :value="'customer'"
                                                                                                            :data-cy="
                                                                                                                'EngagementLetter-' +
                                                                                                                i +
                                                                                                                '-' +
                                                                                                                $t(
                                                                                                                    'engagementLetter.wordings.' +
                                                                                                                        item.name,
                                                                                                                ).split(
                                                                                                                    ' ',
                                                                                                                )[0] +
                                                                                                                '-customer'
                                                                                                            "
                                                                                                        />
                                                                                                        <v-radio
                                                                                                            class="my-0 py-0"
                                                                                                            label="Cabinet"
                                                                                                            :value="'accountant'"
                                                                                                            :data-cy="
                                                                                                                'EngagementLetter-' +
                                                                                                                i +
                                                                                                                '-' +
                                                                                                                $t(
                                                                                                                    'engagementLetter.wordings.' +
                                                                                                                        item.name,
                                                                                                                ).split(
                                                                                                                    ' ',
                                                                                                                )[0] +
                                                                                                                '-Cabinet'
                                                                                                            "
                                                                                                        />
                                                                                                    </v-radio-group>
                                                                                                </template>
                                                                                            </v-col> </v-row
                                                                                    ></v-list-item>
                                                                                </template>
                                                                            </v-list>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-card>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" v-else>
                                            <v-list style="background-color: transparent">
                                                <template
                                                    v-for="(item, index) in data.taskDistribution"
                                                    :key="'a_' + index"
                                                >
                                                    <v-list-item
                                                        class="oss-list-item"
                                                        ripple
                                                        density="compact"
                                                    >
                                                        <v-row
                                                            no-gutters
                                                            class="d-flex justify-end"
                                                        >
                                                            <template v-if="item.custom">
                                                                <v-col
                                                                    :cols="
                                                                        +getWidth(
                                                                            item.spaceNumber,
                                                                        ) - 2
                                                                    "
                                                                    class="pr-2 d-flex align-center"
                                                                >
                                                                    <v-text-field-filled
                                                                        v-model="item.name"
                                                                        label="Nom de la tache"
                                                                        outlined
                                                                        hide-details
                                                                        density="compact"
                                                                    />
                                                                </v-col>
                                                                <v-col
                                                                    cols="2"
                                                                    class="d-flex justify-space-between align-center"
                                                                >
                                                                    <v-row no-gutters>
                                                                        <v-col
                                                                            cols="12"
                                                                            class="d-flex justify-center align-center"
                                                                        >
                                                                            <v-btn-icon
                                                                                icon="$fa-chevron-left"
                                                                                outlined
                                                                                rounded
                                                                                class="mx-1"
                                                                                @click="
                                                                                    item.spaceNumber--
                                                                                "
                                                                                :disabled="
                                                                                    item.spaceNumber ===
                                                                                    0
                                                                                "
                                                                            />
                                                                            <v-btn-icon
                                                                                icon="$fa-chevron-right"
                                                                                outlined
                                                                                rounded
                                                                                class="mx-1"
                                                                                @click="
                                                                                    item.spaceNumber++
                                                                                "
                                                                                :disabled="
                                                                                    item.spaceNumber ===
                                                                                    2
                                                                                "
                                                                            />
                                                                            <v-btn-icon
                                                                                icon="$delete"
                                                                                outlined
                                                                                rounded
                                                                                class="mx-1"
                                                                                @click="
                                                                                    deleteTaskDistributionLine(
                                                                                        index,
                                                                                    )
                                                                                "
                                                                                size="small"
                                                                            />
                                                                        </v-col>
                                                                        <v-col
                                                                            cols="12"
                                                                            class="d-flex justify-center align-center"
                                                                        >
                                                                            <v-switch
                                                                                v-model="
                                                                                    item.isDefinable
                                                                                "
                                                                                hide-details
                                                                                label="Selectionnable"
                                                                                class="mt-0 pt-0 pr-1"
                                                                            />
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </template>
                                                            <v-col
                                                                :cols="getWidth(item.spaceNumber)"
                                                                class="d-flex align-center"
                                                                v-else
                                                            >
                                                                {{
                                                                    $t(
                                                                        "engagementLetter.wordings." +
                                                                            item.name,
                                                                    )
                                                                }}
                                                            </v-col>
                                                            <v-col
                                                                cols="4"
                                                                class="d-flex align-center justify-center"
                                                            >
                                                                <template v-if="item.isDefinable">
                                                                    <v-radio-group
                                                                        color="primary"
                                                                        v-model="item.realizedBy"
                                                                        class="my-0 py-0"
                                                                        :disabled="item.included"
                                                                        :readonly="!isEditable"
                                                                        inline
                                                                        hide-details
                                                                    >
                                                                        <v-radio
                                                                            class="my-0 py-0"
                                                                            label="Client"
                                                                            :value="'customer'"
                                                                        />
                                                                        <v-radio
                                                                            class="my-0 py-0"
                                                                            label="Cabinet"
                                                                            :value="'accountant'"
                                                                        />
                                                                    </v-radio-group>
                                                                </template>
                                                            </v-col> </v-row
                                                    ></v-list-item>
                                                </template>
                                                <v-list-item
                                                    ripple
                                                    class="mt-2"
                                                    two-line
                                                    @click="newTaskDistributionLine()"
                                                    density="compact"
                                                >
                                                    <v-row no-gutters class="d-flex justify-end">
                                                        <v-col
                                                            cols="8"
                                                            class="d-flex align-center justify-center"
                                                        >
                                                            Ajouter un élement
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="d-flex align-center justify-center"
                                                        >
                                                            <v-icon color="primary">$add</v-icon>
                                                        </v-col>
                                                    </v-row></v-list-item
                                                >
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                            </v-tabs-window>
                        </v-col>
                    </v-row>
                    <oss-dialog
                        v-model="dialogProspectedCompany"
                        :title="'Choisir un client'"
                        v-if="dialogProspectedCompany && isEditable"
                        @close="selectCompanyWindow = 0"
                        @valid="validCompany"
                        :hide-valid="selectCompanyWindow !== 1"
                        prefixDataCy="EngagementLetter-client"
                        width="60vw"
                    >
                        <!-- prefixDataCy="EngagementLetter-client" -->
                        <v-window v-model="selectCompanyWindow">
                            <v-window-item value="0">
                                <company-table
                                    :showGenericCompany="false"
                                    :showCustomerCompanies="true"
                                    :showExistingCompanies="false"
                                    :company="
                                        data.prospectedCompany ? data.prospectedCompany.name : ''
                                    "
                                    :siret="
                                        data.prospectedCompany ? data.prospectedCompany.siret : ''
                                    "
                                    :siren="
                                        data.prospectedCompany ? data.prospectedCompany.siren : ''
                                    "
                                    :vatNumber="
                                        data.prospectedCompany
                                            ? data.prospectedCompany.vatNumber
                                            : ''
                                    "
                                    :parentCompanyId="companyId"
                                    @select-company="selectProspectedCompany($event)"
                                    data-cy="test"
                                />
                            </v-window-item>
                            <v-window-item value="0">
                                <editCompany
                                    ref="editCompany"
                                    :adminMode="true"
                                    :in-company="data.prospectedCompany"
                                    @updated="closeDialogProspectedCompany"
                                />
                            </v-window-item>
                        </v-window>
                    </oss-dialog>
                </v-card>
            </v-col>
            <oss-dialog
                v-model="dialogUploadSignedDocument"
                title="Importer la lettre de mission signée par le client"
                @valid="($refs.uploadDocument as any).functionButton()"
                max-width="60vw"
            >
                <UploadDocument
                    ref="uploadDocument"
                    :showFirstPrevious="false"
                    :companyId="companyId"
                    :documentId="documentId"
                    :documentType="'MISCELLANEOUS'"
                    :multiple="false"
                    :freeTag="false"
                    :showBtn="true"
                    @fileUploaded="signed()"
                    @new-document="attachDocumentToEngagementLetter($event)"
                >
                </UploadDocument>
            </oss-dialog>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import UPSERT_ENGAGEMENT_LETTER from "../../graphql/engagementLetter/UpsertEngagementLetter.gql";
import ENGAGEMENT_LETTER from "../../graphql/engagementLetter/EngagementLetter.gql";
import GENERATE_ENGAGEMENT_LETTER from "../../graphql/engagementLetter/GenerateEngagementLetter.gql";
import ENGAGEMENT_LETTER_SIGNATURE from "../../graphql/engagementLetter/EngagementLetterSignature.gql";

import EditCompany from "../EditCompany.vue";
import SelectUser from "../user/SelectUser.vue";
import UploadDocument from "../document/UploadDocuments.vue";
import CompanyTable from "../admin/CompaniesTable.vue";

import InvoiceProductsDialog from "../invoice/InvoiceProductsDialog.vue";

import getEnv from "../../env";
import { NotificationBase } from "../NotificationBase";
import { getSiretValue } from "../../../src/services/companyServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

const env = getEnv();

@Component({
    components: {
        companyTable: CompanyTable,
        editCompany: EditCompany,
        selectUser: SelectUser,
        UploadDocument,
        InvoiceProductsDialog,
    },
})
export class EngagementLetter extends NotificationBase {
    localEnv = env.environnement;
    step = 0;

    panel = 0;

    selectCompanyWindow = 0;

    id_ = "";

    update = 0;

    isLocked = false;

    dialogProspectedCompany = false;

    documentId = "";

    dialogUploadSignedDocument = false;

    actorsTasksDistribution = ["customer", "accountant"];

    taskDistributionBobbeeMode = true;

    taskDistributionUpdatable = true;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    data: any = {
        prospectedCompany: {
            id: "",
            name: "",
            siret: "",
            address: "",
            postalCode: "",
            city: "",
            legalForm: "",
            taxSystem: "",
            registrationTown: "",
            shareCapital: "",
            forecastTurnover: "",
            lastYearTurnover: "",
            establishmentDate: "",
            endFinancialYear: "",
            estimatedNumberOfInvoice: "",
            numberOfBankAccount: "",
            numberOfEmployees: "",
            activityDetails: "",
        },
        prospectedClient: {
            gender: "",
            firstname: "",
            lastname: "",
            phoneNumber: "",
            email: "",
        },
        accountant: {
            email: "",
            firstname: "",
            id: "",
            lastname: "",
            type: "",
        },
        accountingFirmName: "",
        commercialCourt: null,
        items: [],
        invoiceLines: [],
        reccurency: "MONTHLY",
        paymentDelay: 30,
        applicationFee: 0,
        status: "DRAFT",
        contractBegin: null,
        contractEnd: null,
        accounting_email: "",
        accounting_phoneNumber: "",
        contractDateCreation: null,
        localizationCreation: "",
        cg_endOfContractCondition: true,
        taskDistributionBobbeeMode: true,
        documentId: "",
        taskDistribution: [
            {
                name: "K02akdYNWR",
                subs: [
                    { name: "iY4MpgD3Zb", realizedBy: "accountant", isDefinable: true },
                    { name: "FRvxiGJPBn", realizedBy: "accountant", isDefinable: true },
                    { name: "OQd7fxuB2N", realizedBy: "customer", isDefinable: true },
                ],
            },
            {
                name: "GW9YMuwaBm",
                subs: [
                    { name: "xnbNDaWB7f", realizedBy: "customer", isDefinable: true },
                    { name: "kn52JdaYUy", realizedBy: "customer", isDefinable: true },
                    { name: "a8TQmr9wWP", realizedBy: "customer", isDefinable: true },
                    { name: "cKev6NPtUC", realizedBy: "customer", isDefinable: true },
                ],
            },
            {
                name: "tT5UZMRdjw",
                subs: [
                    { name: "m8KWDH3vqy", realizedBy: "accountant", isDefinable: true },
                    { name: "aWQSZp4REv", realizedBy: "accountant", isDefinable: true },
                    { name: "jfU5Zxm7JD", realizedBy: "accountant", isDefinable: true },
                    { name: "k3nd8D2VtL", realizedBy: "accountant", isDefinable: true },
                    { name: "yP9zfKQW2M", realizedBy: "accountant", isDefinable: true },
                    { name: "r97kStERVA", realizedBy: "accountant", isDefinable: true },
                ],
            },
            {
                name: "YC9ynuJeP5",
                subs: [
                    { name: "wkFHb2GJAP", realizedBy: "accountant", isDefinable: true },
                    { name: "x5nNuG2vDR", realizedBy: "accountant", isDefinable: true },
                    { name: "mdSQLgk2FT", realizedBy: "customer", isDefinable: true },
                    { name: "waPf96cuBg", realizedBy: "accountant", isDefinable: true },
                    { name: "xVfQKTAS4J", realizedBy: "accountant", isDefinable: true },
                    { name: "Gu8aLydx4Z", realizedBy: "accountant", isDefinable: true },
                    { name: "adP9qk6ruV", realizedBy: "accountant", isDefinable: true },
                ],
            },
            {
                name: "v5x6T4dqXK",
                subs: [
                    { name: "d5gVAUjW4K", realizedBy: "accountant", isDefinable: true },
                    { name: "DvT4mgBL2F", realizedBy: "accountant", isDefinable: true },
                    { name: "ZB6SJ84pte", realizedBy: "accountant", isDefinable: true },
                    { name: "jug2E5dpXP", realizedBy: "accountant", isDefinable: true },
                    { name: "Hm4hLBTsKV", realizedBy: "accountant", isDefinable: true },
                ],
            },
            {
                name: "qjzT4aDUX3",
                subs: [
                    { name: "Wqe5yrx3QG", realizedBy: "accountant", isDefinable: true },
                    { name: "QZma6Yshdu", realizedBy: "accountant", isDefinable: true },
                    { name: "sY6UHAbNry", realizedBy: "accountant", isDefinable: true },
                ],
            },
            {
                name: "rhMXxB9UC3",
                subs: [
                    { name: "XfT82uWsvy", realizedBy: "customer", isDefinable: true },
                    { name: "khJtBaCR5K", realizedBy: "customer", isDefinable: true },
                    { name: "XVbPAzCf7n", realizedBy: "customer", isDefinable: true },
                    { name: "CkmBHapL57", realizedBy: "customer", isDefinable: true },
                    { name: "xqPEWv6kQA", realizedBy: "customer", isDefinable: true },
                ],
            },
            {
                name: "NzTsy7UjpP",
                subs: [
                    { name: "Ra7Jn58NfQ", realizedBy: "accountant", isDefinable: true },
                    {
                        name: "z73eCdWtAP",
                        realizedBy: "customer",
                        isDefinable: true,
                        included: true,
                    },
                    {
                        name: "bzgHMVcE4F",
                        realizedBy: "customer",
                        isDefinable: true,
                        included: true,
                    },
                    {
                        name: "uJX5hxBt8L",
                        realizedBy: "customer",
                        isDefinable: true,
                        included: true,
                    },
                    {
                        name: "MC3XLwWpnV",
                        realizedBy: "customer",
                        isDefinable: true,
                        included: true,
                    },
                    {
                        name: "rQa6vhUg8G",
                        realizedBy: "customer",
                        isDefinable: true,
                        included: true,
                    },
                    {
                        name: "wXjLR9Ng2b",
                        realizedBy: "customer",
                        isDefinable: true,
                        included: true,
                    },
                ],
            },
        ],
    };

    radioGroup = null;

    get reccurencyTypes() {
        return [
            { text: this.$t("invoice.reccurency.type.annual"), value: "ANNUAL" },
            { text: this.$t("invoice.reccurency.type.biannual"), value: "BIANNUAL" },
            { text: this.$t("invoice.reccurency.type.quarterly"), value: "QUARTERLY" },
            { text: this.$t("invoice.reccurency.type.monthly"), value: "MONTHLY" },
            { text: this.$t("invoice.reccurency.type.bimonthly"), value: "BIMONTHLY" },
        ];
    }

    get months() {
        return [
            { text: this.$t("common.months.January"), value: "January" },
            { text: this.$t("common.months.February"), value: "February" },
            { text: this.$t("common.months.March"), value: "March" },
            { text: this.$t("common.months.April"), value: "April" },
            { text: this.$t("common.months.May"), value: "May" },
            { text: this.$t("common.months.June"), value: "June" },
            { text: this.$t("common.months.July"), value: "July" },
            { text: this.$t("common.months.August"), value: "August" },
            { text: this.$t("common.months.September"), value: "September" },
            { text: this.$t("common.months.October"), value: "October" },
            { text: this.$t("common.months.November"), value: "November" },
            { text: this.$t("common.months.December"), value: "December" },
        ];
    }

    get panelIsNaN() {
        return isNaN(this.panel);
    }

    get id() {
        if (this.id_) {
            return this.id_;
        }
        return (this.$route?.params?.id as string) || "";
    }

    set id(data: string) {
        this.id_ = data;
    }

    get companyId() {
        return this.$store.state.user.company.id;
    }

    get totalPrice() {
        const result = this.data.items.reduce(
            (acc, item) => acc + (item.annualPayment ? item.amount / 12 : item.amount),
            0,
        );
        return result;
    }

    get user() {
        return this.$store.state.user;
    }

    get isValidProspecedCompany() {
        if (
            this.data.prospectedCompany.id &&
            this.data.prospectedCompany.name &&
            this.data.prospectedCompany.address &&
            this.data.prospectedCompany.postalCode &&
            this.data.prospectedCompany.city &&
            this.data.prospectedCompany.legalForm
        ) {
            return true;
        }
        return false;
    }

    get isValidProspectedClient() {
        if (
            this.data.prospectedClient.gender &&
            this.data.prospectedClient.firstname &&
            this.data.prospectedClient.lastname
        ) {
            return true;
        }
        return false;
    }

    get isEditable() {
        return this.data.status === "DRAFT";
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (170 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    getWidth(size) {
        switch (size) {
            case 0:
                return "8";
            case 1:
                return "7";
            case 2:
                return "6";
            default:
                return "8";
        }
    }

    back() {
        this.$router.go(-1);
    }

    newTaskDistributionLine() {
        this.data.taskDistribution.push({
            name: "",
            realizedBy: "accountant",
            spaceNumber: 1,
            isDefinable: true,
            custom: true,
        });
    }

    deleteTaskDistributionLine(index) {
        this.data.taskDistribution = this.data.taskDistribution.filter((x, i) => i !== index);
    }

    onEstablishmentDateChanged(date) {
        this.data.prospectedCompany.establishmentDate = date;
    }

    onContractCreationDateChanged(date) {
        this.data.contractDateCreation = date;
    }

    selectProspectedCompany(company) {
        debugger;
        this.data.prospectedCompany = company;
        // if (!company.id) {
        this.selectCompanyWindow = 1;
        return;
        // }
        // this.dialogProspectedCompany = false;
    }

    async validCompany() {
        // @ts-ignore
        await this.$refs.editCompany.upsertCompany();
        this.dialogProspectedCompany = false;
    }

    get isValid() {
        // STEP 1
        if (
            !this.isValidProspecedCompany ||
            !this.isValidProspectedClient ||
            !this.data ||
            !this.data.accountant ||
            !this.data.accountant.id
        ) {
            return false;
        }

        // STEP 2
        if (
            !this.data.contractBegin ||
            // !this.data.contractEnd ||
            !this.data.localizationCreation ||
            !this.data.contractDateCreation
        ) {
            return false;
        }

        return true;
    }

    addItem() {
        this.data.items.push({ title: "", amount: 0, annualPayment: false });
    }

    @Apollo({
        query() {
            return ENGAGEMENT_LETTER;
        },
        variables() {
            return {
                id: this.id,
            };
        },
        // debounce: 500,
        skip() {
            return !this.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data.engagementLetter) {
                    this.taskDistributionUpdatable = false;
                    this.taskDistributionBobbeeMode =
                        data.engagementLetter.data.taskDistributionBobbeeMode;
                    this.data = data.engagementLetter.data;
                    if (data.engagementLetter.document) {
                        this.documentId = data.engagementLetter.document.id;
                    }
                    if (data.engagementLetter.data.prospectedCompany.endFinancialYear) {
                        let endFinancialYear =
                            data.engagementLetter.data.prospectedCompany.endFinancialYear;
                        if (!moment(endFinancialYear, "YYYY-MM-DD").isValid()) {
                            data.engagementLetter.data.prospectedCompany.endFinancialYear = "";
                        }
                    }
                    this.engagementLetter = data.engagementLetter;
                }
            }
        },
    })
    engagementLetter: any = null;
    // revenueAccountableAccountsVateRate0: Array<any> = [];

    async beforeMount() {
        this.data.accountant = this.user;
        this.data.accountingFirmName = this.user.company.name;
        this.addListener("engagementLetter");
    }

    closeDialogProspectedCompany(data) {
        this.data["prospectedCompany"] = { ...this.data.prospectedCompany, ...data };
        // this.data.prospectedCompany = data
        this.dialogProspectedCompany = false;
    }

    deleteItem(index) {
        this.data.items = this.data.items.filter((x, i) => i !== index);
    }

    accessDialogCompany() {
        if (this.isEditable) {
            this.dialogProspectedCompany = true;
        }
    }

    async save() {
        debugger;
        for (const item of this.data.items) {
            if (!item.product?.id) {
                debugger;
            }
        }
        const invoiceProductIdsList = this.data.items
            .filter((item) => !!item.product?.id)
            .map((item) => ({ id: item.product.id }));
        const variables = {
            id: this.id,
            data: this.data,
            accountantId: this.data.accountant.id,
            companyId: this.companyId,
            status: this.data.status,
            prospectedCompany: this.data.prospectedCompany.id,
            invoiceProductCreate: invoiceProductIdsList.length
                ? { connect: invoiceProductIdsList }
                : undefined,
            invoiceProductUpdate: invoiceProductIdsList.length
                ? { set: invoiceProductIdsList }
                : undefined,
            documentCreate: this.data.documentId
                ? { connect: { id: this.data.documentId } }
                : undefined,
            documentUpdate: this.data.documentId
                ? { connect: { id: this.data.documentId } }
                : undefined,
        };

        const result = await this.$apollo.mutate({
            mutation: UPSERT_ENGAGEMENT_LETTER,
            variables: variables,
        });
        if (!this.id && result.data?.upsertEngagementLetter?.id) {
            this.id = result.data.upsertEngagementLetter.id;
        } else {
            debugger;
        }
    }

    async printPDF() {
        await this.save();
        window.open(
            `${env.VUE_APP_BACKEND}/engagementLetter/download/pdf/${
                this.id
            }?dt="${new Date().getTime()}`,
            "_blank",
        );
    }

    async printDocx() {
        await this.save();
        window.open(
            `${env.VUE_APP_BACKEND}/engagementLetter/download/docx/${
                this.id
            }?dt="${new Date().getTime()}`,
            "_blank",
        );
    }

    async askForSignature() {
        let title;
        if (this.data.prospectedCompany && this.data.prospectedCompany.name) {
            title = this.data.prospectedCompany.name;
        }
        if (
            this.data.prospectedClient &&
            this.data.prospectedClient.lastname &&
            this.data.prospectedClient.firstname
        ) {
            title =
                this.data.prospectedClient.firstname + " " + this.data.prospectedClient.lastname;
        } else {
            title = this.data.accountant.firstname + " " + this.data.accountant.lastname;
        }
        debugger;
        let result = await this.$apollo.mutate({
            mutation: ENGAGEMENT_LETTER_SIGNATURE,
            variables: {
                engagementLetterId: this.id,
                title: title,
                receivers: [this.data.accountant, this.data.prospectedClient],
            },
        });
    }

    async validate() {
        this.data.status = "VALIDATED";
        await this.save();
        await this.$apollo.mutate({
            mutation: GENERATE_ENGAGEMENT_LETTER,
            variables: {
                id: this.id,
            },
        });
        await this.save();
    }

    async modify() {
        this.data.status = "DRAFT";
        await this.save();
    }

    async signed() {
        this.dialogUploadSignedDocument = false;
        this.data.status = "SIGNED";
        await this.save();
    }

    async generate() {
        await this.$apollo.mutate({
            mutation: GENERATE_ENGAGEMENT_LETTER,
            variables: {
                id: this.id,
            },
        });
    }

    addProduct(product: any) {
        debugger;
        const quantity = product.quantity || product.unitQuantity || 1;
        this.data.items.push({
            title: product.title,
            amount: product.unitPrice * (quantity || 1),
            annualPayment: false,
            product,
        });
        this.data.invoiceLines.push();
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    async attachDocumentToEngagementLetter(file: any) {
        this.data.documentId = file.id;
        await this.save();
    }

    @Watch("taskDistributionBobbeeMode")
    taskDistributionTypeChange() {
        if (this.taskDistributionUpdatable) {
            this.data.taskDistributionBobbeeMode = this.taskDistributionBobbeeMode;
            this.update++;
            if (this.taskDistributionBobbeeMode) {
                this.data.taskDistribution = JSON.parse(
                    JSON.stringify(this.taskDistributionByBobbee),
                );
            } else {
                this.data.taskDistribution = JSON.parse(
                    JSON.stringify(this.taskDistributionByDefault),
                );
            }
        }
        this.taskDistributionUpdatable = true;
    }

    taskDistributionByDefault = [
        { name: "Q9zwVKEcNF", realizedBy: "accountant", spaceNumber: 0, isDefinable: false },
        { name: "YbP3n6Q9eW", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "Sme6HMqNLR", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "JezBXh753k", spaceNumber: 0, isDefinable: false },
        { name: "KewS7DcA36", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "fwS4HMAh2f", spaceNumber: 1, isDefinable: false },
        { name: "h9zsZ7Qfb3", realizedBy: "accountant", spaceNumber: 2, isDefinable: true },
        { name: "thmMgERs98", realizedBy: "accountant", spaceNumber: 2, isDefinable: true },
        { name: "js3zPR5fbV", realizedBy: "accountant", spaceNumber: 2, isDefinable: true },
        { name: "ygxTS8xhCh", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "qty9rRa3Vk", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "s7E2HResqP", spaceNumber: 0, isDefinable: false },
        { name: "s8Vx2zYzDs", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "Ns8F4CjEfC", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "fHpn6Z37WF", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "ncqet8HEUW", spaceNumber: 0, isDefinable: false },
        { name: "fJP7usB4FT", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "YvpUGRe8gf", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "aUpv9qjNez", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "Mpwt379Yk5", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "C5EhA9gcKp", isDefinable: false, spaceNumber: 0 },
        { name: "TqtJ2PU3f6", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "UrV6a8z9BZ", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "aX3dV4FkeZ", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "MyF7UdfRCr", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "g9Zp7vGaUH", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "LvbYM2Ec9y", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "s4xC3KGW7X", spaceNumber: 0, isDefinable: false },
        { name: "tF2Uk9QAv4", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "QDukmq5BjF", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "PS97Gt5MTC", spaceNumber: 0, isDefinable: false },
        { name: "D7Nhw5bJxc", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "mvPz24ajtq", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "ZqHwSmF3Ar", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "h9GELn6HVS", spaceNumber: 0, isDefinable: false },
        { name: "je2K9bRfwq", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "rCAT2a4EBZ", realizedBy: "accountant", spaceNumber: 0, isDefinable: false },
        { name: "um7CT6eSMk", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "xKrc7V5d3R", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "D4vd3xu8FX", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "p8fy5JU7zn", spaceNumber: 0, isDefinable: false },
        { name: "bYNdJpu7gB", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "RPXyA9Qesg", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "AJL9z7uUn6", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "LnPxHGyM3z", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "XBDnd9AhLr", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "jbA94pTxVh", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
        { name: "hDSf4bFWK9", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "P8ZvmkS4Lf", realizedBy: "accountant", spaceNumber: 0, isDefinable: true },
        { name: "FSaN2VqTGM", spaceNumber: 0, isDefinable: false },
        { name: "dmypZH6RAK", realizedBy: "accountant", spaceNumber: 1, isDefinable: true },
    ];

    taskDistributionByBobbee = [
        {
            name: "K02akdYNWR",
            subs: [
                { name: "iY4MpgD3Zb", realizedBy: "accountant", isDefinable: true },
                { name: "FRvxiGJPBn", realizedBy: "accountant", isDefinable: true },
                { name: "OQd7fxuB2N", realizedBy: "customer", isDefinable: true },
            ],
        },
        {
            name: "GW9YMuwaBm",
            subs: [
                { name: "xnbNDaWB7f", realizedBy: "customer", isDefinable: true },
                { name: "kn52JdaYUy", realizedBy: "customer", isDefinable: true },
                { name: "a8TQmr9wWP", realizedBy: "customer", isDefinable: true },
                { name: "cKev6NPtUC", realizedBy: "customer", isDefinable: true },
            ],
        },
        {
            name: "tT5UZMRdjw",
            subs: [
                { name: "m8KWDH3vqy", realizedBy: "accountant", isDefinable: true },
                { name: "aWQSZp4REv", realizedBy: "accountant", isDefinable: true },
                { name: "jfU5Zxm7JD", realizedBy: "accountant", isDefinable: true },
                { name: "k3nd8D2VtL", realizedBy: "accountant", isDefinable: true },
                { name: "yP9zfKQW2M", realizedBy: "accountant", isDefinable: true },
                { name: "r97kStERVA", realizedBy: "accountant", isDefinable: true },
            ],
        },
        {
            name: "YC9ynuJeP5",
            subs: [
                { name: "wkFHb2GJAP", realizedBy: "accountant", isDefinable: true },
                { name: "x5nNuG2vDR", realizedBy: "accountant", isDefinable: true },
                { name: "mdSQLgk2FT", realizedBy: "customer", isDefinable: true },
                { name: "waPf96cuBg", realizedBy: "accountant", isDefinable: true },
                { name: "xVfQKTAS4J", realizedBy: "accountant", isDefinable: true },
                { name: "Gu8aLydx4Z", realizedBy: "accountant", isDefinable: true },
                { name: "adP9qk6ruV", realizedBy: "accountant", isDefinable: true },
            ],
        },
        {
            name: "v5x6T4dqXK",
            subs: [
                { name: "d5gVAUjW4K", realizedBy: "accountant", isDefinable: true },
                { name: "DvT4mgBL2F", realizedBy: "accountant", isDefinable: true },
                { name: "ZB6SJ84pte", realizedBy: "accountant", isDefinable: true },
                { name: "jug2E5dpXP", realizedBy: "accountant", isDefinable: true },
                { name: "Hm4hLBTsKV", realizedBy: "accountant", isDefinable: true },
            ],
        },
        {
            name: "qjzT4aDUX3",
            subs: [
                { name: "Wqe5yrx3QG", realizedBy: "accountant", isDefinable: true },
                { name: "QZma6Yshdu", realizedBy: "accountant", isDefinable: true },
                { name: "sY6UHAbNry", realizedBy: "accountant", isDefinable: true },
            ],
        },
        {
            name: "rhMXxB9UC3",
            subs: [
                { name: "XfT82uWsvy", realizedBy: "customer", isDefinable: true },
                { name: "khJtBaCR5K", realizedBy: "customer", isDefinable: true },
                { name: "XVbPAzCf7n", realizedBy: "accountant", isDefinable: true },
                { name: "CkmBHapL57", realizedBy: "accountant", isDefinable: true },
                { name: "xqPEWv6kQA", realizedBy: "accountant", isDefinable: true },
            ],
        },
        {
            name: "NzTsy7UjpP",
            subs: [
                { name: "Ra7Jn58NfQ", realizedBy: "accountant", isDefinable: true },
                { name: "z73eCdWtAP", realizedBy: "customer", isDefinable: true, included: true },
                { name: "bzgHMVcE4F", realizedBy: "customer", isDefinable: true, included: true },
                { name: "uJX5hxBt8L", realizedBy: "customer", isDefinable: true, included: true },
                { name: "MC3XLwWpnV", realizedBy: "customer", isDefinable: true, included: true },
                { name: "rQa6vhUg8G", realizedBy: "customer", isDefinable: true, included: true },
                { name: "wXjLR9Ng2b", realizedBy: "customer", isDefinable: true, included: true },
            ],
        },
    ];

    commercialCourts = [
        { text: "01 - Ain", value: { region: "Ain", prefix: "de l'" } },
        { text: "02 - Aisne", value: { region: "Aisne", prefix: "de l'" } },
        { text: "03 - Allier", value: { region: "Allier", prefix: "de l'" } },
        {
            text: "04 - Alpes-de-Haute-Provence",
            value: { region: "Alpes-de-Haute-Provence", prefix: "des" },
        },
        { text: "05 - Hautes-Alpes", value: { region: "Hautes-Alpes", prefix: "des" } },
        { text: "06 - Alpes-Maritimes", value: { region: "Alpes-Maritimes", prefix: "des" } },
        { text: "07 - Ardèche", value: { region: "Ardèche", prefix: "de l'" } },
        { text: "08 - Ardennes", value: { region: "Ardennes", prefix: "des" } },
        { text: "09 - Ariège", value: { region: "Ariège", prefix: "de l'" } },
        { text: "10 - Aube", value: { region: "Aube", prefix: "de l'" } },
        { text: "11 - Aude", value: { region: "Aude", prefix: "de l'" } },
        { text: "12 - Aveyron", value: { region: "Aveyron", prefix: "de l'" } },
        { text: "13 - Bouches-du-Rhône", value: { region: "Bouches-du-Rhône", prefix: "des" } },
        { text: "14 - Calvados", value: { region: "Calvados", prefix: "du" } },
        { text: "15 - Cantal", value: { region: "Cantal", prefix: "du" } },
        { text: "16 - Charente", value: { region: "Charente", prefix: "de la" } },
        { text: "17 - Charente-Maritime", value: { region: "Charente-Maritime", prefix: "de la" } },
        { text: "18 - Cher", value: { region: "Cher", prefix: "du" } },
        { text: "19 - Corrèze", value: { region: "Corrèze", prefix: "de la" } },
        { text: "2A - Corse-du-Sud", value: { region: "Corse-du-Sud", prefix: "de la" } },
        { text: "2B - Corse du Nord", value: { region: "Corse du Nord", prefix: "de la" } },
        { text: "21 - Côte-d'Or", value: { region: "Côte-d'Or", prefix: "de la" } },
        { text: "22 - Côtes-d'Armor", value: { region: "Côtes-d'Armor", prefix: "des" } },
        { text: "23 - Creuse", value: { region: "Creuse", prefix: "de la" } },
        { text: "24 - Dordogne", value: { region: "Dordogne", prefix: "de la" } },
        { text: "25 - Doubs", value: { region: "Doubs", prefix: "du" } },
        { text: "26 - Drôme", value: { region: "Drôme", prefix: "du" } },
        { text: "27 - Eure", value: { region: "Eure", prefix: "de l'" } },
        { text: "28 - Eure-et-Loir", value: { region: "Eure-et-Loir", prefix: "de l'" } },
        { text: "29 - Finistère", value: { region: "Finistère", prefix: "du" } },
        { text: "30 - Gard", value: { region: "Gard", prefix: "du" } },
        { text: "31 - Haute Garonne", value: { region: "Haute Garonne", prefix: "de la" } },
        { text: "32 - Gers", value: { region: "Gers", prefix: "du" } },
        { text: "33 - Gironde", value: { region: "Gironde", prefix: "de la" } },
        { text: "34 - Hérault", value: { region: "Hérault", prefix: "de" } },
        { text: "35 - Ille-et-Vilaine", value: { region: "Ille-et-Vilaine", prefix: "de l'" } },
        { text: "36 - Indre", value: { region: "Indre", prefix: "de l'" } },
        { text: "37 - Indre-et-Loire", value: { region: "Indre-et-Loire", prefix: "de l'" } },
        { text: "38 - Isère", value: { region: "Isère", prefix: "de l'" } },
        { text: "39 - Jura", value: { region: "Jura", prefix: "du" } },
        { text: "40 - Landes", value: { region: "Landes", prefix: "des" } },
        { text: "41 - Loir-et-Cher", value: { region: "Loir-et-Cher", prefix: "du" } },
        { text: "42 - Loire", value: { region: "Loire", prefix: "de la" } },
        { text: "43 - Haute Loire", value: { region: "Haute Loire", prefix: "de la" } },
        { text: "44 - Loire-Atlantique", value: { region: "Loire-Atlantique", prefix: "de" } },
        { text: "45 - Loiret", value: { region: "Loiret", prefix: "du" } }, // a verifier
        { text: "46 - Lot", value: { region: "Lot", prefix: "du" } },
        { text: "47 - Lot-et-Garonne", value: { region: "Lot-et-Garonne", prefix: "du" } },
        { text: "48 - Lozère", value: { region: "Lozère", prefix: "de" } }, // a verifier
        { text: "49 - Maine-et-Loire", value: { region: "Maine-et-Loire", prefix: "de la" } },
        { text: "50 - Manche", value: { region: "Manche", prefix: "de la" } },
        { text: "51 - Marne", value: { region: "Marne", prefix: "de la" } },
        { text: "52 - Haute-Marne", value: { region: "Haute-Marne", prefix: "de la" } },
        { text: "53 - Mayenne", value: { region: "Mayenne", prefix: "de" } },
        {
            text: "54 - Meurthe-et-Moselle",
            value: { region: "Meurthe-et-Moselle", prefix: "de la" },
        },
        { text: "55 - Meuse", value: { region: "Meuse", prefix: "de la" } },
        { text: "56 - Morbihan", value: { region: "Morbihan", prefix: "du" } },
        { text: "57 - Moselle", value: { region: "Moselle", prefix: "de" } },
        { text: "58 - Nièvre", value: { region: "Nièvre", prefix: "de" } },
        { text: "59 - Nord", value: { region: "Nord", prefix: "du" } },
        { text: "60 - Oise", value: { region: "Oise", prefix: "de l'" } },
        { text: "61 - Orne", value: { region: "Orne", prefix: "de l'" } }, // a verifier
        { text: "62 - Pas-de-Calais", value: { region: "Pas-de-Calais", prefix: "du" } },
        { text: "63 - Puy-de-Dôme", value: { region: "Puy-de-Dôme", prefix: "du" } },
        {
            text: "64 - Pyrénées-Atlantiques",
            value: { region: "Pyrénées-Atlantiques", prefix: "des" },
        },
        { text: "65 - Hautes Pyrénées", value: { region: "Hautes Pyrénées", prefix: "des" } },
        {
            text: "66 - Pyrénées-Orientales",
            value: { region: "Pyrénées-Orientales", prefix: "des" },
        },
        { text: "67 - Bas Rhin", value: { region: "Bas Rhin", prefix: "du" } },
        { text: "68 - Haut Rhin", value: { region: "Haut Rhin", prefix: "du" } },
        { text: "69 - Rhône", value: { region: "Rhône", prefix: "du" } },
        { text: "70 - Haute Saône", value: { region: "Haute Saône", prefix: "de la" } },
        { text: "71 - Saône-et-Loire", value: { region: "Saône-et-Loire", prefix: "de" } },
        { text: "72 - Sarthe", value: { region: "Sarthe", prefix: "de" } }, // a verifier
        { text: "73 - Savoie", value: { region: "Savoie", prefix: "de" } },
        { text: "74 - Haute Savoie", value: { region: "Haute Savoie", prefix: "de" } },
        { text: "75 - Paris", value: { region: "Paris", prefix: "de" } },
        { text: "76 - Seine-Maritime", value: { region: "Seine-Maritime", prefix: "de la" } },
        { text: "77 - Seine-et-Marne", value: { region: "Seine-et-Marne", prefix: "de" } },
        { text: "78 - Yvelines", value: { region: "Yvelines", prefix: "des" } },
        { text: "79 - Deux Sèvres", value: { region: "Deux Sèvres", prefix: "des" } },
        { text: "80 - Somme", value: { region: "Somme", prefix: "de la" } },
        { text: "82 - Tarn-et-Garonne", value: { region: "Tarn-et-Garonne", prefix: "de" } },
        { text: "83 - Var", value: { region: "Var", prefix: "du" } },
        { text: "84 - Vaucluse", value: { region: "Vaucluse", prefix: "du" } },
        { text: "85 - Vendée", value: { region: "Vendée", prefix: "de" } },
        { text: "86 - Vienne", value: { region: "Vienne", prefix: "de" } },
        { text: "87 - Haute Vienne", value: { region: "Haute Vienne", prefix: "de la" } },
        { text: "88 - Vosges", value: { region: "Vosges", prefix: "des" } },
        {
            text: "90 - Territoire de Belfort",
            value: { region: "Territoire de Belfort", prefix: "du" },
        },
        { text: "91 - Essonne", value: { region: "Essonne", prefix: "de l'" } },
        { text: "92 - Hauts de Seine", value: { region: "Hauts de Seine", prefix: "de" } },
        { text: "93 - Seine-Saint-Denis", value: { region: "Seine-Saint-Denis", prefix: "de" } },
        { text: "94 - Val-de-Marne", value: { region: "Val-de-Marne", prefix: "du" } },
        { text: "95 - Val-d'Oise", value: { region: "Val-d'Oise", prefix: "du" } },
        { text: "971 - Guadeloupe", value: { region: "Guadeloupe", prefix: "de" } },
        { text: "972 - Martinique", value: { region: "Martinique", prefix: "de la" } },
        { text: "974 - Réunion", value: { region: "Réunion", prefix: "de la" } },
    ];
}

export default toNative(EngagementLetter);
</script>

<style lang="scss" scoped>
.inside_card {
    background: white !important;
    padding: 2px;
    border-radius: 16px;
    border: solid 1px rgba($color: #000000, $alpha: 0.12);
}
.text-red-custom {
    color: red !important;
}
</style>
